import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white p-4 absolute bottom-0 left-0 w-full">
      <div className="container px-4 flex-row">

        <p className="text-sm text-purple-400 text-center">
          Sugan Pandurengan
        </p>

        <p className="text-sm text-gray-400 text-center">
          Building solutions with passion
        </p>
      </div>
    </footer>
  );
};

export default Footer;
